// import React from 'react';
// import logo from './logo.svg';
// import '../App.css';
// import Nav from '../components/nav.component';
// import Header from '../components/header.component'
// import About from '../components/about.component'
// import Footer from '../components/footer.component'
// import {Row,Col,Container} from 'reactstrap';
//
// function Home() {
//     return (
//         <div className="App">
//             <Nav/>
//             <Header/>
//             <About/>
//             <Footer/>
//
//         </div>
//     );
// }
//
// export default Home;

import React from 'react';
import logo from './logo.svg';
import '../App.css';
import Nav from '../components/nav.component';
import Footer from '../components/footer.component'
import Articles from '../components/articles.component'
import {Row,Col,Container} from 'reactstrap';
import {Table} from "react-bootstrap";
import {Colors} from '../constants/colors'
// @ts-ignore
import AOS from 'aos';
import 'aos/dist/aos.css';

function Home() {
    AOS.init({
        duration: 2000,
    })
    // const mystyle = {
    //     homeBtn: "green"
    // };
    return (

        <div className="Home">

            {/*<Nav/>*/}
            <div style={{position:'relative'}} >
                <Row>
                    <Col md="4" xs="12" style={{alignItems:'center'}}>
                        <div data-aos="fade-up" data-aos-offset="100" style={{alignContent:"center",alignItems:'center',display:"flex",justifyContent:"center",padding:100}}>
                            <img src="assets/img/cover_2026-4-1-AJPS.jpeg" width='300px' style={{boxShadow: '0px 0px 6px #115b84'}}/>
                        </div>
                    </Col>
                    <Col md="5" xs="12" style={{background:"white"}}>
                        <Container>
                            <Row >
                                <Container>
                                    <div data-aos="fade-up" data-aos-offset="100" style={{
                                        fontSize: 25,
                                        textAlign: 'left',
                                        wordSpacing: 3,
                                        paddingTop: 75,
                                        color: 'black',
                                        fontWeight:'bold'
                                        // marginTop:10
                                        // fontFamily:'Itim',
                                    }}>
                                        ASIAN JOURNAL OF POLITICS AND SOCIETY (AJPS)
                                    </div>

                                    <div data-aos="fade-up" data-aos-offset="100" style={{
                                        fontSize: 15,
                                        textAlign: 'left',
                                        wordSpacing: 3,
                                        paddingTop: 5,
                                        paddingBottom: 5,
                                        color: 'black'
                                        // marginTop:10
                                        // fontFamily:'Itim',
                                    }}>
                                        The Asian Journal of Politics and Society (AJPS) is an international open-access, peer-reviewed, bi-annual, refereed, and quality-guaranteed e-journal that is published by the Department of Social Sciences, Faculty of Social Sciences and Languages, Sabaragamuwa University of Sri Lanka.
                                    </div>

                                    <div data-aos="fade-up" data-aos-offset="100" style={{
                                        fontSize: 15,
                                        textAlign: 'left',
                                        wordSpacing: 3,
                                        paddingTop: 5,
                                        paddingBottom: 15,
                                        color: 'black'
                                        // marginTop:10
                                        // fontFamily:'Itim',
                                    }}>
                                        The journal’s main aim is to provide a platform for academics, scholars, resource persons and practitioners to publish their research findings with the rest of the world in order for informed decisions to be taken to improve society as a whole. The journal welcomes articles from researchers interested in theoretical developments/debates, results of research that advance understanding of fundamental social and political processes, important methodological innovations, empirical analysis, policy implementation, and pragmatic themes and issues in Anthropology, Sociology, Social Work, Political Science, International Relations and Peace Studies. This journal welcomes and is willing to publish articles that are both technically sound and driven by sound reasoning.
                                    </div>
                                </Container>

                            </Row>
                        </Container>

                    </Col>
                    <Col md="3" xs="12" style={{background:"white"}}>
                        <Container>
                            <div data-aos="fade-up" data-aos-offset="100" style={{
                                fontSize: 15,
                                textAlign: 'left',
                                wordSpacing: 3,
                                paddingTop: 80,
                                paddingBottom: 2,
                                color: 'black'
                                // marginTop:10
                                // fontFamily:'Itim',
                            }}>
                                ISSN: 2989-011x
                            </div>
                            {/*<div data-aos="fade-up" data-aos-offset="100"*/}
                            {/*     style={{*/}
                            {/*         fontSize: 15,*/}
                            {/*         textAlign: 'left',*/}
                            {/*         wordSpacing: 3,*/}
                            {/*         paddingTop: 5,*/}
                            {/*         paddingBottom: 15,*/}
                            {/*         color: 'black'*/}
                            {/*         // marginTop:10*/}
                            {/*         // fontFamily:'Itim',*/}
                            {/*     }}>*/}
                            {/*    e-ISSN: 2989-0527*/}
                            {/*</div>*/}
                            <div data-aos="fade-up" data-aos-offset="100"
                                 style={{
                                     fontSize: 15,
                                     textAlign: 'left',
                                     wordSpacing: 3,
                                     paddingTop: 5,
                                     paddingBottom: 15,
                                     color: 'black'
                                     // marginTop:10
                                     // fontFamily:'Itim',
                                 }}>
                                Publisher: Department of Social Sciences, Faculty of Social Sciences and Languages, Sabaragamuwa University of Sri Lanka
                            </div>
			    
                        </Container>

                    </Col>
                </Row>
                <Row style={{paddingBottom:50}}>
		    <Col md="1" xs="12" style={{alignItems:'center'}}>
                    </Col>

                    <Col md="6" xs="12" style={{alignItems:'center'}}>
                        <Articles/>
                    </Col>
		    <Col md="2" xs="12" style={{alignItems:'center'}}>

                    </Col>

		    <Col md="3" xs="12" style={{alignItems:'center'}}>
		<div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 25,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 5,
                    paddingBottom: 15,
                    color: 'black',
                    fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>


<div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 25,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 5,
                    paddingBottom: 15,
                    color: 'black',
                    fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>






<div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 25,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 5,
                    paddingBottom: 15,
                    color: 'black',
                    fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    Volume 03 | Issue 02
                </div>
		<div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 5,
                    paddingBottom: 0,
                    color: 'black',
                    fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    <a style={{textDecoration:'none'}} href='assets/articles/2025-3-2-AJPS-full.pdf' target='_blank' rel="noreferrer">
                        Full Paper
                    </a>
                </div>

		<hr data-aos="fade-up" data-aos-offset="100"/>
		<div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 5,
                    paddingBottom: 0,
                    color: 'black',
                    fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    <a style={{textDecoration:'none'}} href='assets/articles/2025-2-AJPS-01.pdf' target='_blank' rel="noreferrer">
                    Conflict as a Determinant of Cognitive Social Capital of Multi-Ethnic Communities in the Post-Conflict Sri Lanka
                    </a>
       		</div>
        	<div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 3,
                    paddingBottom: 15,
                    color: 'black',
                    // fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                     S. Sivayesunesan, H.M.S. Priyanath, and R. Ramasamy
        	</div>

        	<hr data-aos="fade-up" data-aos-offset="100"/>
		<div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 5,
                    paddingBottom: 0,
                    color: 'black',
                    fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    <a style={{textDecoration:'none'}} href='assets/articles/2025-2-AJPS-02.pdf' target='_blank' rel="noreferrer">
                   Sensitivity of Water and Hygiene among Women in Slum Communities of Sri Lanka
                    </a>
                </div>
                <div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 3,
                    paddingBottom: 15,
                    color: 'black',
                    // fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    F.M.T. Rifka, and S.Gunasekara
                </div>

        	<hr data-aos="fade-up" data-aos-offset="100"/>
		<div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 5,
                    paddingBottom: 0,
                    color: 'black',
                    fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    <a style={{textDecoration:'none'}} href='assets/articles/2025-2-AJPS-03.pdf' target='_blank' rel="noreferrer">
                    The Evolution of Constitutional Provisions for Human Rights in Sri Lanka: Rhetoric Vs. Reality
                    </a>
                </div>
                <div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 3,
                    paddingBottom: 15,
                    color: 'black',
                    // fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    A.S.A. Gunasekera and R.D.P.S. Rajapakshe
                </div>

        	<hr data-aos="fade-up" data-aos-offset="100"/>
		<div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 5,
                    paddingBottom: 0,
                    color: 'black',
                    fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    <a style={{textDecoration:'none'}} href='assets/articles/2025-2-AJPS-04.pdf' target='_blank' rel="noreferrer">
                    Geopolitical Rivalry in South Asia: India-Sri Lanka Relations Amidst China's Strategic Expansion
                    </a>
                </div>
                <div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 3,
                    paddingBottom: 15,
                    color: 'black',
                    // fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    H.E.N. Priyadarshani
                </div>

        	<hr data-aos="fade-up" data-aos-offset="100"/>
		<div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 5,
                    paddingBottom: 0,
                    color: 'black',
                    fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    <a style={{textDecoration:'none'}} href='assets/articles/2025-2-AJPS-05.pdf' target='_blank' rel="noreferrer">
                    Employee Motivation and Personality as Drivers of Performance: A Comparative Study of Public and Private Organizations in Gampaha District
                    </a>
                </div>
                <div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 3,
                    paddingBottom: 15,
                    color: 'black',
                    // fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    A. N. Nuwanthika
                </div>






<div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 25,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 5,
                    paddingBottom: 15,
                    color: 'black',
                    fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    Volume 03 | Issue 01
                </div>
		<div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 5,
                    paddingBottom: 0,
                    color: 'black',
                    fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    <a style={{textDecoration:'none'}} href='assets/articles/AJPS volume 3 issue 1 2025-02.pdf' target='_blank' rel="noreferrer">
                        Full Paper
                    </a>
                </div>

		<hr data-aos="fade-up" data-aos-offset="100"/>
		<div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 5,
                    paddingBottom: 0,
                    color: 'black',
                    fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    <a style={{textDecoration:'none'}} href='assets/articles/2025-1-AJPS - 01.pdf' target='_blank' rel="noreferrer">
                    The Multidimensional Effect of Social Capital on Livelihood Success: Evidence from Members in Community-Based Organizations in Sri Lanka
                    </a>
       		</div>
        	<div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 3,
                    paddingBottom: 15,
                    color: 'black',
                    // fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    M. D. R. Sachintha and H. M. S. Priyanath
        	</div>

        	<hr data-aos="fade-up" data-aos-offset="100"/>
		<div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 5,
                    paddingBottom: 0,
                    color: 'black',
                    fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    <a style={{textDecoration:'none'}} href='assets/articles/2025-1-AJPS - 02.pdf' target='_blank' rel="noreferrer">
                   The Impact of Population Aging on Labor Force Productivity in the Public Sector of Sri Lanka: A Case Study of the Greater Kandy Urban Development Programme
                    </a>
                </div>
                <div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 3,
                    paddingBottom: 15,
                    color: 'black',
                    // fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    N. V. L. Chamali and G. C. L. Pathirana
                </div>

        	<hr data-aos="fade-up" data-aos-offset="100"/>
		<div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 5,
                    paddingBottom: 0,
                    color: 'black',
                    fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    <a style={{textDecoration:'none'}} href='assets/articles/2025-1-AJPS - 03.pdf' target='_blank' rel="noreferrer">
                    Exploring the Intersection of Buddhist Ethics and Human Rights Legislation through Compatibility and Contradictions
                    </a>
                </div>
                <div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 3,
                    paddingBottom: 15,
                    color: 'black',
                    // fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    K. M. Theekshana Pasan Deepaloka
                </div>

        	<hr data-aos="fade-up" data-aos-offset="100"/>
		<div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 5,
                    paddingBottom: 0,
                    color: 'black',
                    fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    <a style={{textDecoration:'none'}} href='assets/articles/2025-1-AJPS - 04.pdf' target='_blank' rel="noreferrer">
                    Strategic Balancing or Dependency? An Analysis of Sri Lanka's Foreign Policy Dynamics with India and China
                    </a>
                </div>
                <div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 3,
                    paddingBottom: 15,
                    color: 'black',
                    // fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    R. D. P. Sampath Rajapakshe
                </div>

        	<hr data-aos="fade-up" data-aos-offset="100"/>
		<div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 5,
                    paddingBottom: 0,
                    color: 'black',
                    fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    <a style={{textDecoration:'none'}} href='assets/articles/2025-1-AJPS - 05.pdf' target='_blank' rel="noreferrer">
                    Creating Women Visionaries to Lead the Country’s Development Merely a Job of The State Universities? A Sri Lankan Case Study
                    </a>
                </div>
                <div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 3,
                    paddingBottom: 15,
                    color: 'black',
                    // fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    P. K. G. I. L. Ranasinghe
                </div>









{/* --------------------------------------------2-2-------------------------------------------------------------------------- */}



                    Volume 02 | Issue 02
                </div>
		<div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 5,
                    paddingBottom: 0,
                    color: 'black',
                    fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    <a style={{textDecoration:'none'}} href='assets/articles/2024-2-AJPS.pdf' target='_blank' rel="noreferrer">
                        Full Paper
                    </a>
                </div>

		<hr data-aos="fade-up" data-aos-offset="100"/>
		<div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 5,
                    paddingBottom: 0,
                    color: 'black',
                    fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    <a style={{textDecoration:'none'}} href='assets/articles/2024-2-AJPS-01.pdf' target='_blank' rel="noreferrer">
                    The Effect of Long-Distance Leadership and Work from Home on the Employees� Performance of the Public Sector Workers in Sri Lanka
                    </a>
       		</div>
        	<div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 3,
                    paddingBottom: 15,
                    color: 'black',
                    // fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    B. Y. G. W. Miththrananda
        	</div>

        	<hr data-aos="fade-up" data-aos-offset="100"/>
		<div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 5,
                    paddingBottom: 0,
                    color: 'black',
                    fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    <a style={{textDecoration:'none'}} href='assets/articles/2024-2-AJPS-02.pdf' target='_blank' rel="noreferrer">
                    A Study of Victims� Perceptions on Post War Reconciliation Efforts by the Government of Sri Lanka
                    </a>
                </div>
                <div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 3,
                    paddingBottom: 15,
                    color: 'black',
                    // fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    Suranjith Gunasekara
                </div>

        	<hr data-aos="fade-up" data-aos-offset="100"/>
		<div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 5,
                    paddingBottom: 0,
                    color: 'black',
                    fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    <a style={{textDecoration:'none'}} href='assets/articles/2024-2-AJPS-03.pdf' target='_blank' rel="noreferrer">
                    The Patterns of Short Video Usage and Its Impact and Consequences for Older Adults in Rural China
                    </a>
                </div>
                <div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 3,
                    paddingBottom: 15,
                    color: 'black',
                    // fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    Hu Liang
                </div>

        	<hr data-aos="fade-up" data-aos-offset="100"/>
		<div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 5,
                    paddingBottom: 0,
                    color: 'black',
                    fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    <a style={{textDecoration:'none'}} href='assets/articles/2024-2-AJPS-04.pdf' target='_blank' rel="noreferrer">
                    Applying the �One-Stop-Shop� Strategy for a Citizen-Centric Public Service Delivery in Sri Lanka: A Case Study of Magam Ruhunupura 
                    Administrative Building Complex
                    </a>
                </div>
                <div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 3,
                    paddingBottom: 15,
                    color: 'black',
                    // fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    Mayuri Kularathne
                </div>

        	<hr data-aos="fade-up" data-aos-offset="100"/>
		<div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 5,
                    paddingBottom: 0,
                    color: 'black',
                    fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    <a style={{textDecoration:'none'}} href='assets/articles/2024-2-AJPS-05.pdf' target='_blank' rel="noreferrer">
                    The Modern Role of the Military in Ensuring National Security from Fighting Insurgency to Human Security in Sri Lanka: 
                    A Case Study of the Northern Province
                    </a>
                </div>
                <div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 3,
                    paddingBottom: 15,
                    color: 'black',
                    // fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    D. G. R. N. Rukshan
                </div>





                    Volume 02 | Issue 01
                </div>
                <div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 5,
                    paddingBottom: 0,
                    color: 'black',
                    fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    <a style={{textDecoration:'none'}} href='assets/articles/2024-1-AJPS.pdf' target='_blank' rel="noreferrer">
                        Full Paper
                    </a>
                </div>
                <hr data-aos="fade-up" data-aos-offset="100" />
                <div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 5,
                    paddingBottom: 0,
                    color: 'black',
                    fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    <a style={{textDecoration:'none'}} href='assets/articles/2024-1-AJPS-01.pdf' target='_blank' rel="noreferrer">
                        Sociocultural Discourses of Suicide in Sri Lanka: An Overview of Literature
                    </a>
                </div>
                <div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 3,
                    paddingBottom: 15,
                    color: 'black',
                    // fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    Susantha Rasnayake
                </div>
                <hr data-aos="fade-up" data-aos-offset="100"/>
		<div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 5,
                    paddingBottom: 0,
                    color: 'black',
                    fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    <a style={{textDecoration:'none'}} href='assets/articles/2024-1-AJPS-02.pdf' target='_blank' rel="noreferrer">
                        The Role of Microcredit on Women Empowerment in Sri Lanka: Evidence from Samurdhi Program Beneficiaries in Weligama Divisional Secretariat Division                    </a>
                </div>
                <div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 3,
                    paddingBottom: 15,
                    color: 'black',
                    // fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    A.A.F. Ilma
                </div>
                <hr data-aos="fade-up" data-aos-offset="100"/>
		<div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 5,
                    paddingBottom: 0,
                    color: 'black',
                    fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    <a style={{textDecoration:'none'}} href='assets/articles/2024-1-AJPS-03.pdf' target='_blank' rel="noreferrer">
                        Impact of Financial Literacy on the Performance of Small and Medium-Sized Enterprises: Special Reference to Colombo District
		    </a>
                </div>
                <div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 3,
                    paddingBottom: 15,
                    color: 'black',
                    // fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    G.G.K. Janithri
                </div>
                <hr data-aos="fade-up" data-aos-offset="100"/>
		<div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 5,
                    paddingBottom: 0,
                    color: 'black',
                    fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    <a style={{textDecoration:'none'}} href='assets/articles/2024-1-AJPS-04.pdf' target='_blank' rel="noreferrer">
                        Differential Impact on the Students  Performance in the Grade Five Scholarship Examination in Sri Lanka: Based on the Nuwara-Eliya District
		    </a>
                </div>
                <div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 3,
                    paddingBottom: 15,
                    color: 'black',
                    // fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    R.M.L. Rathnayake
                </div>
                <hr data-aos="fade-up" data-aos-offset="100"/>
		<div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 5,
                    paddingBottom: 0,
                    color: 'black',
                    fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    <a style={{textDecoration:'none'}} href='assets/articles/2024-1-AJPS-05.pdf' target='_blank' rel="noreferrer">
                        A Book Review of Destined for War: Can America and China Escape Thucydides's Trap?
		    </a>
                </div>
                <div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 3,
                    paddingBottom: 15,
                    color: 'black',
                    // fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    Aruna Jayathilaka
                </div>
                <hr data-aos="fade-up" data-aos-offset="100"/>





                    <div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 25,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 5,
                    paddingBottom: 15,
                    color: 'black',
                    fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    Volume 01 | Issue 02
                </div>

		<div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 5,
                    paddingBottom: 0,
                    color: 'black',
                    fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    <a style={{textDecoration:'none'}} href='assets/articles/2023-2-AJPS.pdf' target='_blank' rel="noreferrer">
                        Full Paper
                    </a>
                </div>

                <hr data-aos="fade-up" data-aos-offset="100" />
                <div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 5,
                    paddingBottom: 0,
                    color: 'black',
                    fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    <a style={{textDecoration:'none'}} href='assets/articles/2023-2-AJPS-01.pdf' target='_blank' rel="noreferrer">
                        Social Connection, Stigma and Mental Health Issues: Experiences of People with Mental Health Issues in Colombo District, Sri Lanka
                    </a>
                </div>
                <div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 3,
                    paddingBottom: 15,
                    color: 'black',
                    // fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    K.A. Epasinghe
                </div>


                <hr data-aos="fade-up" data-aos-offset="100" />
                <div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 5,
                    paddingBottom: 0,
                    color: 'black',
                    fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    <a style={{textDecoration:'none'}} href='assets/articles/2023-2-AJPS-02.pdf' target='_blank'  rel="noreferrer">
                        Study on Factors Identification on Nutritional Status Among Children: An Econometrics Analysis
                    </a>
                </div>
                <div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 3,
                    paddingBottom: 15,
                    color: 'black',
                    // fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    W.R.K.M. Wimalasiri
                </div>


                <hr data-aos="fade-up" data-aos-offset="100" />
                <div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 5,
                    paddingBottom: 0,
                    color: 'black',
                    fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    <a style={{textDecoration:'none'}} href='assets/articles/2023-2-AJPS-03.pdf' target='_blank'  rel="noreferrer">
                        Nature and the Relevance of the World Balance of Power after World War II
                    </a>
                </div>
                <div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 3,
                    paddingBottom: 15,
                    color: 'black',
                    // fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    H.E.N. Priyadarshani
                </div>

                <hr data-aos="fade-up" data-aos-offset="100" />
                <div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 5,
                    paddingBottom: 0,
                    color: 'black',
                    fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    <a style={{textDecoration:'none'}} href='assets/articles/2023-2-AJPS-04.pdf' target='_blank'  rel="noreferrer">
                        Identifying Social Risk Factors of Child Undernutrition in the Nuwara-Eliya District, Sri Lanka                    
		    </a>
                </div>
                <div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 3,
                    paddingBottom: 15,
                    color: 'black',
                    // fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    R.M.L. Rathnayake
                </div>



                <hr data-aos="fade-up" data-aos-offset="100" />
                <div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 5,
                    paddingBottom: 0,
                    color: 'black',
                    fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    <a style={{textDecoration:'none'}} href='assets/articles/2023-2-AJPS-05.pdf' target='_blank'  rel="noreferrer">
                        A Book Review of <q>Liquid Love: On the Frailty of Human Bonds</q>
                    </a>
                </div>
                <div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 3,
                    paddingBottom: 15,
                    color: 'black',
                    // fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    M.N. Vineeshiya
                </div>
		<div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 25,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 5,
                    paddingBottom: 15,
                    color: 'black',
                    fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    Volume 01 | Issue 01
                </div>

                {/*<hr data-aos="fade-up" data-aos-offset="100" />*/}
                {/*<div data-aos="fade-up" data-aos-offset="100" style={{*/}
                {/*    fontSize: 15,*/}
                {/*    textAlign: 'left',*/}
                {/*    wordSpacing: 3,*/}
                {/*    paddingTop: 5,*/}
                {/*    paddingBottom: 0,*/}
                {/*    color: 'black',*/}
                {/*    fontWeight:"bold",*/}
                {/*    // marginTop:10*/}
                {/*    // fontFamily:'Itim',*/}
                {/*}}>*/}
                {/*    <a style={{textDecoration:'none'}} target='_blank'>*/}
                {/*        Editorial Note*/}
                {/*    </a>*/}
                {/*</div>*/}
        
                <div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 5,
                    paddingBottom: 0,
                    color: 'black',
                    fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    <a style={{textDecoration:'none'}} href='assets/articles/2023-1-AJPS.pdf' target='_blank' rel="noreferrer">
                        Full Paper
                    </a>
                </div>

                <hr data-aos="fade-up" data-aos-offset="100" />
                <div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 5,
                    paddingBottom: 0,
                    color: 'black',
                    fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    <a style={{textDecoration:'none'}} href='assets/articles/2023-1-AJPS-01.pdf' target='_blank' rel="noreferrer">
                        Universal Buddhist Pantheon in Post-War Sri Lanka
                    </a>
                </div>
                <div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 3,
                    paddingBottom: 15,
                    color: 'black',
                    // fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    Mahesh Premarathna
                </div>


                <hr data-aos="fade-up" data-aos-offset="100" />
                <div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 5,
                    paddingBottom: 0,
                    color: 'black',
                    fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    <a style={{textDecoration:'none'}} href='assets/articles/2023-1-AJPS-02.pdf' target='_blank'  rel="noreferrer">
                        Gender Differences in the Determinants of Business Performance among Entrepreneurs of the Tourism Industry in Sri Lanka

                    </a>
                </div>
                <div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 3,
                    paddingBottom: 15,
                    color: 'black',
                    // fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    Saman Handaragama
                </div>


                <hr data-aos="fade-up" data-aos-offset="100" />
                <div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 5,
                    paddingBottom: 0,
                    color: 'black',
                    fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    <a style={{textDecoration:'none'}} href='assets/articles/2023-1-AJPS-03.pdf' target='_blank'  rel="noreferrer">
                        War Memories and Their Impact on the Ethnic Reconciliation Process in Sri Lanka
                    </a>
                </div>
                <div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 3,
                    paddingBottom: 15,
                    color: 'black',
                    // fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    Suranjith Gunasekara
                </div>

                <hr data-aos="fade-up" data-aos-offset="100" />
                <div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 5,
                    paddingBottom: 0,
                    color: 'black',
                    fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    <a style={{textDecoration:'none'}} href='assets/articles/2023-1-AJPS-04.pdf' target='_blank'  rel="noreferrer">
                        Criminalising Dissent: Sri Lanka�s Prevention of Terrorism Act and Its Use in Suppressing Social Movements - 2022                   
		    </a>
                </div>
                <div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 3,
                    paddingBottom: 15,
                    color: 'black',
                    // fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    Vishanka Gunawardana
                </div>

                <hr data-aos="fade-up" data-aos-offset="100" />
                <div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 5,
                    paddingBottom: 0,
                    color: 'black',
                    fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    <a style={{textDecoration:'none'}} href='assets/articles/2023-1-AJPS-05.pdf' target='_blank'  rel="noreferrer">
                        Uncovering the Methods of Operation and Funding of Armed Groups in the MENA Region: A Special Focus on Libya and Yemen

                    </a>
                </div>
                <div data-aos="fade-up" data-aos-offset="100" style={{
                    fontSize: 15,
                    textAlign: 'left',
                    wordSpacing: 3,
                    paddingTop: 3,
                    paddingBottom: 15,
                    color: 'black',
                    // fontWeight:"bold"
                    // marginTop:10
                    // fontFamily:'Itim',
                }}>
                    Mohamad Zreik
                </div>

                    </Col>
                </Row>
            </div>
            <Footer/>

        </div>
    );
}

export default Home;
